import React, { useState } from 'react';
import { Justify, Segment } from 'tea-component';
import { getLocale, useIntl, useSelector } from 'umi';

import './index.scss';
import DataSourceSelector from '../DataSourceSelector';

interface tab {
  [key: string]: Array<Object>;
}

export default function BreakDownHeader(props: any) {
  const { options, defaultValue, onChange, formValue, AccumatedConfig, style, isCnClass = true } = props;
  const { isHaveAccumulatedSelector = false, accumatedOptions, accumatedDefault, onAccumatedChange } = AccumatedConfig || {};
  const { formatMessage } = useIntl(); // 中英切换方法
  const data_frame = useSelector((state: any) => {
    return state?.dashboard?.currentGame?.data_frame || 'mobile';
  });

  const [breakDownType, setBreakDownType] = useState(defaultValue || 'country');

  const isEN = getLocale() === 'en-US';

  const BREAK_DOWN_TAB_MOBILE_LIST = [
    { text: formatMessage({ id: 'common_Country' }), value: 'country' },
    { text: formatMessage({ id: 'common_Region' }), value: 'region' },
    { text: formatMessage({ id: 'common_Zone' }), value: 'zone' }
  ];

  const BREAK_DOWN_TAB_PC_LIST = [
    { text: formatMessage({ id: 'common_Country' }), value: 'country' },
    { text: formatMessage({ id: 'common_System' }), value: 'os' },
    { text: formatMessage({ id: 'common_Region' }), value: 'region' }
  ];

  // const BREAK_DOWN_TAB_PC_INFLEXION_LIST = [
  //   { text: formatMessage({ id: 'common_Country' }), value: 'country' },
  //   { text: formatMessage({ id: 'common_Region' }), value: 'region' },
  //   { text: formatMessage({ id: 'common_System' }), value: 'os' },
  // ]

  // 可能pc_inflexion的时候不一定是BREAK_DOWN_TAB_PC_INFLEXION_LIST，看后续需求处理
  const breakDownTab: tab = {
    default: BREAK_DOWN_TAB_MOBILE_LIST,
    mobile: BREAK_DOWN_TAB_MOBILE_LIST,
    pc: BREAK_DOWN_TAB_PC_LIST
    // 当前代码只有churn的mobile和Pc Console 相关的页面用到了data_frame，其他地方用到这个组件的都是配置化页面，
    // 从外部传入了参数所以pc_inflexion可以直接先删除，后续data_frame可能就没有pc_inflexion的值了
    // pc_inflexion:BREAK_DOWN_TAB_PC_INFLEXION_LIST,
  };

  return (
    <Justify
      className='register-justify-mb'
      left={
        <>
          {isHaveAccumulatedSelector && (
            <DataSourceSelector
              className='dbd-nightingale-daily-select'
              onSelect={onAccumatedChange}
              formValue={formValue}
              defaultValue={accumatedDefault}
              optionsData={accumatedOptions}
            />
          )}
          <Segment
            style={style}
            className={isEN ? 'segment-light' : `segment-light ${isCnClass ? 'segment-light-china' : ''}`}
            value={breakDownType}
            onChange={val => {
              onChange && onChange(val);
              setBreakDownType(val);
            }}
            options={options ? options : breakDownTab?.[data_frame] || breakDownTab?.default}
          />
        </>
      }
    />
  );
}
